import gql from "graphql-tag";
const getResultJSQuery = gql(` 
query runJSResult($params: AWSJSON!) {
  runJSResult(params: $params) {
    id
    status
    profile
    penalty
    coords
    cycles
    batches
    nearest
    distance
    geo
    meta
    quantity
    filtered
    result
  }
}
`)
export default getResultJSQuery;
